import accounting from "accounting";

window.accounting = accounting;

export default accounting;
